var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.774297 1.82684C0.890363 1.57668 1.14107 1.41663 1.41684 1.41663H15.5835C15.8593 1.41663 16.11 1.57668 16.226 1.82684C16.3421 2.077 16.3024 2.37178 16.1244 2.58235L10.6252 9.08515V14.875C10.6252 15.1205 10.4981 15.3484 10.2892 15.4775C10.0804 15.6066 9.81964 15.6183 9.60006 15.5085L6.76673 14.0918C6.52676 13.9719 6.37517 13.7266 6.37517 13.4583V9.08515L0.875977 2.58235C0.697904 2.37178 0.658231 2.077 0.774297 1.82684ZM2.94351 2.83329L7.62437 8.3684C7.7325 8.49628 7.79184 8.65833 7.79184 8.82579V13.0205L9.20851 13.7289V8.82579C9.20851 8.65833 9.26784 8.49628 9.37598 8.3684L14.0568 2.83329H2.94351Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1aed8d140ca9861ffddaf45b9a5ecdb1.svg";
export { ForwardRef as ReactComponent };